<div class="popper" #container [style.visibility]="visible ? 'visible' : 'hidden'" [style.width]="width">
    <div data-popper-arrow></div>
    <ng-content></ng-content>
</div>
